import React from 'react'
import { t } from 'ttag'

import SurveyQuestionList from './SurveyQuestionList'
import SurveyCreationForm from './SurveyCreationForm'

const SurveyListModal = ({
  surveys,
  selectForEdit,
  onCreateNewSurvey,
  onSaveSurvey,
  unselectForEdit,
  selected,
  selectedQuestion,
  onMoveQuestion,
  onDeleteQuestion,
  onSelectQuestion,
  onSelectSurveyToRename,
  renameTitleActive,
  onRenameSurvey,
  onClone,
  handleSurveyNameChange,
  onSaveQuestion,
  onCancelRenameSurvey,
  isUserPremium
}) => {
  const editLink = survey => {
    if (survey.systemSurvey) {
      return <span>{survey.name}</span>
    }

    return (
      <a href="javascript:void(0)" onClick={() => selectForEdit(survey.id)}>
        {survey.name}
      </a>
    )
  }

  if (selected) {
    if (selected === 'new') {
      return (
        <SurveyCreationForm
          onCancel={unselectForEdit}
          onSave={onSaveSurvey}
          canCreateShared={!isUserPremium}
        />
      )
    }

    return (
      <SurveyQuestionList
        unselectForEdit={unselectForEdit}
        isUserPremium={isUserPremium}
        onMoveQuestion={onMoveQuestion}
        onDeleteQuestion={onDeleteQuestion}
        onSelectSurveyToRename={onSelectSurveyToRename}
        selectedQuestion={selectedQuestion}
        onSelectQuestion={onSelectQuestion}
        onRenameSurvey={onRenameSurvey}
        onCancelRenameSurvey={onCancelRenameSurvey}
        handleSurveyNameChange={handleSurveyNameChange}
        renameTitleActive={renameTitleActive}
        onSaveQuestion={onSaveQuestion}
        selected={selected}
      />
    )
  }

  return (
    <table className="table tbl">
      <thead>
        <tr>
          <th>{t`Survey Name`}</th>
          <th>{t`Action`}</th>
        </tr>
      </thead>
      <tbody>
        {surveys.map((s, idx) => (
          <tr key={s.id} className={idx % 2 === 0 ? 'even' : 'odd'}>
            <td>{editLink(s)}</td>
            <td>
              <button className="btn btn-sm btn-submit" onClick={() => onClone(s.id)}>
                {t`Duplicate`}
              </button>
            </td>
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr>
          <td colSpan="2" className="text-center">
            <button className="btn btn-submit" onClick={onCreateNewSurvey}>
              {t`Add New Survey`}
            </button>
          </td>
        </tr>
      </tfoot>
    </table>
  )
}

export default SurveyListModal
